import React from "react";
import { CaresContextType } from "../types";
import "./ContextChip.css";

interface ContextChipProps {
  contextType: CaresContextType;
  contextPath: string;
  onChange: (value: CaresContextType) => void;
}

const ContextChip: React.FC<ContextChipProps> = ({
  contextType,
  contextPath,
  onChange,
}) => {
  return (
    <div className="mrc-context">
      <div className="mrc-context__switch" role="radiogroup" aria-label="What is this about?">
        <button
          type="button"
          role="radio"
          aria-checked={contextType === "page"}
          className={`mrc-context__option${contextType === "page" ? " mrc-context__option--active" : ""}`}
          onClick={() => onChange("page")}
        >
          This page
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={contextType === "general"}
          className={`mrc-context__option${contextType === "general" ? " mrc-context__option--active" : ""}`}
          onClick={() => onChange("general")}
        >
          Something else
        </button>
      </div>
      {contextType === "page" && (
        <div className="mrc-context__chip" title={contextPath}>
          {contextPath}
        </div>
      )}
    </div>
  );
};

export default ContextChip;
